import React from "react";
import AttributesPositives from "../../components/AttributesPositives/AttributesPositives";

export default function SingleAttributesPositives() {
    return (
        <AttributesPositives />
    )
}
